import { ILessonRepository } from "@app/features/Lesson/data/lessonRepository";
import { TEditLessonViewModel } from "@app/features/Lesson/view/Edit/editLessonViewModel";

const editLessonUseCase = async (
  repository: Pick<ILessonRepository, "editLesson">,
  data: TEditLessonViewModel
) => {
  await repository.editLesson(data);
};

export default editLessonUseCase;
